import {createApp} from 'vue'
import App from './App.vue'
import router from "./router"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App);
// 注册消息提示插件
app.use(router)
app.use(ElementPlus);
app.mount('#app');




